/**
 * Base class for all tracking-related errors
 */
export class TrackingError extends Error {
  constructor(message: string, public cause?: Error) {
    super(message);
    this.name = this.constructor.name;
  }
}

/**
 * Error thrown when event validation fails
 */
export class TrackingValidationError extends TrackingError {
  constructor(message: string, public validationError: Error) {
    super(message, validationError);
  }
}

/**
 * Error thrown when a provider fails to initialize
 */
export class TrackingProviderInitError extends TrackingError {
  constructor(providerName: string, message: string, cause?: Error) {
    super(`Initialization failed: ${message}`, cause);
  }
}

/**
 * Error thrown when a provider is not found
 */
export class TrackingProviderNotFoundError extends TrackingError {
  constructor(providerName: string) {
    super(`Provider not found: ${providerName}`);
  }
}

/**
 * Error thrown when the event queue is full
 */
export class TrackingQueueFullError extends TrackingError {
  constructor(maxSize: number) {
    super(`Queue is full (max size: ${maxSize})`);
  }
}

/**
 * Error thrown when an event type is not recognized
 */
export class TrackingUnknownEventTypeError extends TrackingError {
  constructor(eventType: string) {
    super(`Unknown event type: ${eventType}`);
  }
}

/**
 * Error thrown when there's an issue with local storage
 */
export class TrackingStorageError extends TrackingError {
  constructor(operation: string, cause?: Error) {
    super(`Storage operation failed: ${operation}`, cause);
  }
}
